/**
 * Determines if the current page is a Settings or User Settings page.
 * Settings and User Settings pages should store configuration only in localStorage, not in the database.
 *
 * @param moduleId - Optional module ID. If "settings", it's a Settings page.
 * @param path - Optional path. If not provided, uses window.location.pathname.
 */
export function isSettingsPage(moduleId?: string | null, path?: string): boolean {
  if (moduleId === "settings") {
    return true;
  }

  const currentPath = path ?? (typeof window !== "undefined" ? window.location.pathname : "");

  if (currentPath.startsWith("/settings")) {
    return true;
  }

  return currentPath.startsWith("/user-settings");
}
